module.exports = __webpack_public_path__ + "img/7.a5b6fa5b.png";